import { render, staticRenderFns } from "./addRule.vue?vue&type=template&id=1b3b0630&scoped=true&"
import script from "./addRule.vue?vue&type=script&lang=js&"
export * from "./addRule.vue?vue&type=script&lang=js&"
import style0 from "./addRule.vue?vue&type=style&index=0&id=1b3b0630&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b0630",
  null
  
)

export default component.exports